/* src/app/hire-talent-insights/hire-quick-search/hire-quick-search.component.scss */
.hire-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
  border-radius: 4px;
  background: #FFF;
  gap: 10px;
  margin-bottom: 12px;
}
.wc-checkbox {
  width: 16px !important;
  height: 16px !important;
}
.wc-checkbox input[type=checkbox] {
  width: 16px !important;
  height: 16px !important;
}
.bb-1 {
  border-bottom: 1px solid #F2F2F2;
}
.common-chip {
  border-radius: 6px;
  padding: 5px 10px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 10px;
  color: #68AA86;
  display: flex;
  background:
    linear-gradient(
      0deg,
      rgba(104, 170, 134, 0.1) 0%,
      rgba(104, 170, 134, 0.1) 100%),
    #FFF;
}
.warning {
  border-radius: 6px;
  color: #FBA744;
  background:
    linear-gradient(
      0deg,
      rgba(251, 167, 68, 0.1) 0%,
      rgba(251, 167, 68, 0.1) 100%),
    #FFF;
}
.errror {
  border-radius: 6px;
  color: #E57777;
  background:
    linear-gradient(
      0deg,
      rgba(229, 119, 119, 0.1) 0%,
      rgba(229, 119, 119, 0.1) 100%),
    #FFF;
}
.badge {
  border-radius: 0 8px 8px 0;
  font-size: 12px;
  font-weight: 500;
  padding: 8px 16px 8px 30px;
  position: relative;
}
.badge::before {
  position: absolute;
  display: block;
  content: "";
  left: 0;
  top: 0;
  width: 0px;
  height: 0px;
  border-top: 14px solid transparent;
  border-bottom: 14px solid transparent;
  border-left: 18px solid #ffffff;
}
.not-fit {
  background: #FCF1F1;
  color: #E57777;
}
.excellent-fit {
  background: #F0F7F3;
  color: #68AA86;
}
.potential-fit {
  background: #FFF6EC;
  color: #FFA133;
}
.hire-search-card {
  padding: 8px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 4px;
  margin-bottom: 12px;
}
.hire-search-card input.wc-form-control {
  border-radius: 4px;
  border: 1px solid #F2F2F2;
}
.filter-criteria-cta {
  padding: 8px 8px;
  border-radius: 4px;
  background: #EAF4F6;
  display: flex;
  align-items: center;
  justify-content: start;
  outline: none;
  border: 0px;
  font-size: 12px;
  height: 36px;
  color: #484b59;
}
.fl-count {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 12px;
  background-color: #2E93A1;
}
.toggle-container {
  background-color: #f7f7f7;
  border-radius: 4px;
  display: flex;
  padding: 2px;
  font-size: 12px;
  font-weight: 500;
  position: relative;
}
.toggle-container .activebtn,
.toggle-container .activeClass {
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 18px;
  font-weight: 600;
  border: 1px solid transparent;
  height: auto;
  cursor: pointer;
}
.toggle-container .activeClass {
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  height: 100%;
  transition: left 0.3s ease-in-out;
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 18px;
  font-weight: 600;
  border: 1px solid transparent;
  height: auto;
}
.toggle-container .insight-btn.activeClass {
  left: 50%;
}
.toggle-container .insight-btn,
.toggle-container .profile-btn {
  background-color: #f2f2f2;
  color: #969696;
  border-radius: 6px;
  padding: 9px 18px;
  font-weight: 500;
  border: 1px solid transparent;
  height: auto;
  position: relative;
  cursor: pointer;
}
.toggle-container .insight-btn:hover,
.toggle-container .profile-btn:hover {
  background-color: #E8E8E8;
  color: #484b59;
}
.toggle-container .activeClass {
  position: absolute;
  z-index: 1;
  left: 0;
  width: 100%;
  height: 100%;
  transition: left 0.3s ease-in-out;
  background-color: #2E93A1;
  color: #fff;
  border-radius: 3px;
  padding: 9px 18px;
  font-weight: 600;
  border: 1px solid transparent;
  height: auto;
}
.toggle-container .insight-btn.activeClass {
  left: 50%;
}
.toggle-container .profile-btn.activeClass {
  left: -50%;
}
.toggle-container .inactivebtn {
  background-color: #f2f2f2;
  color: #969696;
  border-radius: 6px;
  padding: 9px 18px;
  font-weight: 500;
  border: 1px solid transparent;
  height: auto;
  cursor: pointer;
}
.toggle-container .inactivebtn:hover {
  background-color: #E8E8E8;
  color: #484b59;
}
.ats-dropBtn button {
  padding: 0;
  border: none;
  color: #969696;
  outline: none;
  background-color: #fff;
}
.ats-dropBtn button.dropdown-toggle::after {
  display: none;
}
.ats-dropBtn .dropdown-menu.show {
  left: -125px !important;
  transform: translate3d(-33px, 17px, 0px) !important;
  padding: 0;
  overflow: hidden;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item {
  padding: 0.75rem 0.75rem;
}
.ats-dropBtn .dropdown-menu.show .dropdown-item:hover {
  background-color: #E4F1F3;
}
.sm-reg-btn {
  width: auto;
  min-width: auto;
}
.talenpool-sticky-header {
  box-shadow: rgba(17, 17, 26, 0.1) 0px 3px 5px;
}
.hover-btn {
  transition: all 0.4s ease-in-out;
}
.hover-btn:hover {
  background-color: rgba(46, 147, 161, 0.1019607843);
}
.add-to button.btn-trms-light {
  background-color: #F4F4F4;
  color: #484b59;
}
.add-to .dropdown-menu.show {
  top: 40px;
  left: -55px;
  width: 220px;
  height: 160px;
  overflow-y: auto;
  border-radius: 4px;
  border: 1px solid #F5F5F5;
  background: #FFF;
  box-shadow: rgba(0, 0, 0, 0.15) 0px 5px 15px 0px;
  font-size: 12px;
}
.add-to .dropdown-menu.show .dropdown-item {
  padding: 8px 10px;
}
.add-to .dropdown-menu.show .dropdown-item:hover {
  background-color: #F4F9FA;
  color: #2E93A1 !important;
}
.add-to .dropdown-menu.show .optionheader {
  padding: 10px;
  position: relative;
  color: #969696;
}
.add-to .dropdown-menu.show .optionheader::after {
  position: absolute;
  display: block;
  content: "";
  width: 25%;
  height: 2px;
  background-color: #F2F2F2;
  right: 10px;
  top: 16px;
}
.add-to .dropdown-menu.show::-webkit-scrollbar {
  width: 3px !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-track {
  background: #F2F2F2 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb {
  background: #D9D9D9 !important;
}
.add-to .dropdown-menu.show::-webkit-scrollbar-thumb:hover {
  background: #555 !important;
}
.add-to.show .dropdown-toggle::after {
  transform: rotate(-180deg);
  transition: transform 0.2s ease-in;
}
.create-project-btn-dropdown {
  border: 0;
  outline: none;
  background-color: #fff;
  color: #484b59;
  padding: 6px 10px;
}
.back-link-btn {
  background-color: transparent;
  color: #484b59;
}
input.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
.files-card {
  display: flex;
  padding: 7px 8px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  border-radius: 4px;
  border: 1px solid #F2F2F2;
  background: #FCFCFC;
  flex-direction: column;
  margin-bottom: 10px;
}
.btn-svg {
  border: none;
  outline: none;
  background-color: transparent;
  padding: 5px;
}
::ng-deep .progress {
  background-color: #F4F4F4 !important;
  border-radius: 10px !important;
}
::ng-deep .progress-bar {
  border-radius: 10px !important;
}
::ng-deep .progress-bar.text-bg-success {
  background-color: #2E93A1 !important;
}
textarea.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  min-height: 100px;
}
input.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
select.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 34px;
}
.label-style {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 6px;
}
.contact-cta {
  display: flex;
  width: 16px;
  height: 16px;
  padding: 3.326px 3px 2.674px 3px;
  justify-content: center;
  align-items: center;
  aspect-ratio: 1/1;
  border-radius: 100px;
  background: #E6F2F4;
}
.helpfull-label {
  display: flex;
  height: 18px;
  padding: 0 8px;
  align-items: center;
  gap: 4px;
  border-radius: 12px;
  border: 1px solid #F2F2F2;
  background: #FAFAFA;
}
.table-view,
.table-view-3-column {
  border-radius: 4px;
  border: 1px solid #F2F2F2;
  overflow: hidden;
}
.table-view .table-header-row,
.table-view .table-body-row,
.table-view-3-column .table-header-row,
.table-view-3-column .table-body-row {
  display: flex;
  align-items: stretch;
  gap: 0;
  background-color: #FAFBFC;
  border-bottom: 1px solid #F2F2F2;
}
.table-view .table-header-row .table-header-col,
.table-view .table-header-row .table-body-col,
.table-view .table-body-row .table-header-col,
.table-view .table-body-row .table-body-col,
.table-view-3-column .table-header-row .table-header-col,
.table-view-3-column .table-header-row .table-body-col,
.table-view-3-column .table-body-row .table-header-col,
.table-view-3-column .table-body-row .table-body-col {
  width: 30%;
  padding: 6.68px 16px;
  color: #5E5E5E;
  font-size: 12px;
  font-weight: 500;
  align-content: start;
  border-right: 1px solid #F2F2F2;
}
.table-view .table-header-row .table-header-col:last-child,
.table-view .table-header-row .table-body-col:last-child,
.table-view .table-body-row .table-header-col:last-child,
.table-view .table-body-row .table-body-col:last-child,
.table-view-3-column .table-header-row .table-header-col:last-child,
.table-view-3-column .table-header-row .table-body-col:last-child,
.table-view-3-column .table-body-row .table-header-col:last-child,
.table-view-3-column .table-body-row .table-body-col:last-child {
  border-right: none;
  width: 70%;
}
.table-view .table-header-row .table-header-col:first-child,
.table-view .table-header-row .table-body-col:first-child,
.table-view .table-body-row .table-header-col:first-child,
.table-view .table-body-row .table-body-col:first-child,
.table-view-3-column .table-header-row .table-header-col:first-child,
.table-view-3-column .table-header-row .table-body-col:first-child,
.table-view-3-column .table-body-row .table-header-col:first-child,
.table-view-3-column .table-body-row .table-body-col:first-child {
  width: 30%;
}
.table-view .table-body-row,
.table-view-3-column .table-body-row {
  background-color: #ffffff;
}
.table-view .table-body-row:last-child,
.table-view-3-column .table-body-row:last-child {
  border-bottom: none;
}
.table-view .table-body-row .table-body-col,
.table-view-3-column .table-body-row .table-body-col {
  color: #5E5E5E;
  font-weight: 400;
}
.table-view-3-column .table-header-row .table-header-col,
.table-view-3-column .table-header-row .table-body-col,
.table-view-3-column .table-body-row .table-header-col,
.table-view-3-column .table-body-row .table-body-col {
  padding: 6.68px 16px;
  color: #5E5E5E;
  font-size: 12px;
  font-weight: 500;
  border-right: 1px solid #F2F2F2;
  width: 40%;
  align-content: start;
  gap: 0;
}
.table-view-3-column .table-header-row .table-header-col:last-child,
.table-view-3-column .table-header-row .table-body-col:last-child,
.table-view-3-column .table-body-row .table-header-col:last-child,
.table-view-3-column .table-body-row .table-body-col:last-child {
  border-right: none;
  width: 40%;
}
.table-view-3-column .table-header-row .table-header-col:first-child,
.table-view-3-column .table-header-row .table-body-col:first-child,
.table-view-3-column .table-body-row .table-header-col:first-child,
.table-view-3-column .table-body-row .table-body-col:first-child {
  width: 24%;
}
::ng-deep ngb-pagination .pagination .page-item a.page-link {
  font-size: 12px !important;
}
::ng-deep .mat-mdc-tooltip.hire-tooltip {
  max-width: 500px !important;
  width: 500px !important;
}
::ng-deep .mat-mdc-tooltip.hire-tooltip .mat-mdc-tooltip-surface {
  box-shadow: 0 0 4px 0 #e2e0e0;
  font-family: "Poppins", sans-serif !important;
  font-size: 12px !important;
  font-weight: 400;
  font-family: "Poppins", sans-serif !important;
  max-width: 100% !important;
}
.hire-search-card-filters {
  padding: 8px 12px;
  align-items: center;
  justify-content: space-between;
  background-color: #ffffff;
  border-radius: 4px;
  margin-bottom: 12px;
}
.empty-content {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 0 auto;
  height: 80vh;
}
.toggle-container2 {
  position: relative;
  display: inline-flex;
  background: #e5e5e5;
  border-radius: 20px;
  padding: 4px;
  cursor: pointer;
}
.toggle-container2 span {
  position: relative;
  z-index: 2;
  padding: 6px 16px;
  font-size: 14px;
  color: #555;
  transition: color 0.3s ease;
}
.toggle-container2 span.active {
  color: #fff;
}
.toggle-slider2 {
  position: absolute;
  top: 4px;
  left: 4px;
  width: 50%;
  height: calc(100% - 8px);
  background: #28a745;
  border-radius: 20px;
  transition: transform 0.3s ease;
  z-index: 1;
  color: #fff;
}
.toggle-slider2.insights {
  transform: translateX(100%);
}
.toggle-slider2.profiles {
  transform: translateX(0%);
}
.ml-auto {
  margin-left: auto;
}
.pos-sticky-top {
  position: sticky;
  top: 16px;
  z-index: 7;
  box-shadow: 0 8px 6px -6px rgba(0, 0, 0, 0.05);
}
.pos-sticky-top::before {
  content: "";
  display: block;
  position: absolute;
  width: 100%;
  height: 16px;
  background-color: #fafbfc;
  top: -16px;
  left: 0;
}
.pipeline-export-modal-content {
  border-radius: 7px !important;
  overflow: hidden;
}
.pipeline-export-modal-content .modal-header {
  background-color: #f7f8f9;
  border-radius: 10px 10px 0 0;
  border-bottom: none;
}
.pipeline-export-modal-content .modal-header .btn-close {
  background-color: #f7f8f9;
  box-shadow: none !important;
  outline: none !important;
}
.pipeline-export-modal-content .modal-header .btn-close:focus,
.pipeline-export-modal-content .modal-header .btn-close:active {
  box-shadow: none !important;
  outline: none !important;
}
.pipeline-export-options {
  display: flex;
  flex-direction: column;
}
.pipeline-export-options .pipeline-export-option {
  display: flex;
  align-items: center;
  padding: 0.65rem 0.25rem;
  font-size: 13px;
  color: #484b59;
  cursor: pointer;
  border-bottom: 1px solid #f0f0f0;
}
.pipeline-export-options .pipeline-export-option:last-child {
  border-bottom: none;
}
.pipeline-export-options .pipeline-export-option:hover {
  background-color: #e4f1f3;
  color: #2e93a1;
}
.pipeline-export-options .pipeline-export-option.disabled {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}
.pipeline-export-options .pipeline-export-option-icon {
  width: 20px;
  margin-right: 10px;
  text-align: center;
  color: #969696;
}
.hire-btn-primary {
  background-color: #2E93A1;
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  border: 1px solid #2E93A1;
}
.hire-btn-success {
  background-color: #28a745;
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  border: 1px solid #28a745;
}
.hire-btn-danger {
  background-color: #dc3545;
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  border: 1px solid #dc3545;
}
.hire-btn-warning {
  background-color: #ffc107;
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  border: 1px solid #ffc107;
}
.hire-btn-secondary {
  background-color: #ffffff;
  color: #fff;
  outline: none;
  border: none;
  padding: 6px 16px;
  border-radius: 3px;
  font-size: 14px;
  font-weight: 500;
  display: inline-block;
  border: 1px solid #D5DEE6;
  color: #2E93A1;
}
.filter-layout {
  background: #fff;
  overflow: hidden;
  position: relative;
}
.fl-header {
  width: 100%;
  height: auto;
  background-color: #F2F2F2;
  display: flex;
  align-items: center;
  padding: 16px 20px;
  justify-content: space-between;
  position: sticky;
  top: 0;
  z-index: 1;
}
.fl-container {
  display: flex;
  width: 100%;
}
.fl-container .side-panel {
  width: 32%;
  display: flex;
  padding: 12px 12px;
  align-items: flex-start;
  gap: 6px;
  align-self: stretch;
  border-right: 1px solid #EEF2F5;
}
.fl-container .side-panel .tab-list {
  list-style: none;
  margin: 0;
  padding: 0 0px;
  flex: 1;
  overflow-y: auto;
}
.fl-container .side-panel .tab-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 12px;
  margin-bottom: 0px;
  border-radius: 4px;
  cursor: pointer;
  position: relative;
  transition: background-color 0.18s ease, color 0.18s ease;
  color: #484b59;
  font-size: 14px;
  font-weight: 500;
  outline: none;
  -webkit-user-select: none;
  user-select: none;
}
.fl-container .side-panel .active {
  border-radius: 4px;
  background-color: #F4F9FA;
  font-weight: 500;
}
.fl-container .side-panel .active .tab-icon {
  filter: drop-shadow(0 0 6px rgba(108, 140, 255, 0.25));
}
.fl-container .side-panel .list-group {
  border: none;
  width: 100%;
}
.fl-container .side-panel .list-group .list-group-item {
  border: none;
  padding: 12px 6px;
  display: flex;
  align-items: center;
}
.fl-container .side-panel .list-group .list-group-item span {
  margin-right: 5px;
}
.fl-container .content-body {
  display: flex;
  width: 68%;
  height: calc(100vh - 100px);
  overflow-y: auto;
  padding: 20px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  scroll-behavior: smooth;
}
.fl-container .content-body::-webkit-scrollbar {
  width: 4px;
}
.fl-container .content-body::-webkit-scrollbar-track {
  background: transparent;
}
.fl-container .content-body::-webkit-scrollbar-thumb {
  background: #F2F2F2;
  border-radius: 3px;
}
.fl-container .content-body .filter-groups-section {
  width: 100%;
  margin-bottom: 24px;
}
.fl-container .content-body .filter-groups-section:last-child {
  padding-bottom: 200px;
}
.fl-container .content-body textarea.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  min-height: 100px;
}
.fl-container .content-body input.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 8px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
.fl-container .content-body select.wc-form-control {
  border: 1px solid #D5DEE6;
  padding: 4px 12px;
  border-radius: 4px;
  width: 100%;
  display: block;
  font-size: 12px;
  height: 30px;
}
.fl-container .content-body .label-style {
  font-size: 12px;
  font-weight: 500;
  margin-bottom: 6px;
}
.fl-container .content-body .dropdown-caret {
  position: relative;
  width: fit-content;
}
.fl-container .content-body .dropdown-caret::after {
  content: "";
  display: flex;
  position: absolute;
  right: 3px;
  top: 5px;
  width: 12px;
  height: 12px;
  color: #484b59;
  font-size: 12px;
  transition: rotate 0.3s ease;
  background-image: url("./media/caret-down-S5OF35ZE.svg");
  background-size: contain;
  background-repeat: no-repeat;
}
.fl-container .content-body .dropdown-caret.distance-dropdown select.caret-remove {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  min-width: 80px;
}
.fl-container .content-body .dropdown-caret.distance-dropdown::after {
  right: 7px;
  top: 8px;
}
.fl-container .content-body .custom-select {
  min-width: 50px;
  width: 70px;
  padding: 4px 6px;
  border: 1px solid #ccc;
  border-radius: 6px;
  background: #fff;
  font-size: 12px;
  cursor: pointer;
  color: #484b59;
}
.fl-container .content-body .custom-select:focus {
  outline: none;
  border-color: #007bff;
}
.fl-container .content-body select.custom-select {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
}
.fl-container .content-body select.caret-remove {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  min-width: 70px;
}
.fl-container .content-body select.caret-remove2 {
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  min-width: 105px;
}
.highlight-pill {
  max-width: max-content;
  width: -moz-max-content;
  width: max-content;
  padding: 4px 8px;
  border-radius: 30px;
  align-items: center;
  font-weight: 12px;
  cursor: pointer;
  font-weight: 400;
}
.highlight-pill img {
  width: 12px;
}
.disabled-input {
  pointer-events: none;
  background-color: #eaeaea !important;
}
.save-input {
  background-color: #f8f8f8;
}
::ng-deep div.mat-mdc-autocomplete-panel {
  padding: 6px 0 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar {
  width: 4px;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar-track {
  background: #f1f1f1 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar-thumb {
  background: #969696 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel::-webkit-scrollbar-thumb:hover {
  background: #555 !important;
}
::ng-deep div.mat-mdc-autocomplete-panel .mat-mdc-option {
  min-height: 30px !important;
  padding: 0 12px !important;
  font-size: 12px !important;
  letter-spacing: inherit !important;
}
::ng-deep .p-multiselect-label.p-placeholder {
  font-size: 12px !important;
  color: #969696 !important;
  font-weight: normal !important;
}
::ng-deep .p-component * {
  box-sizing: border-box;
  width: auto !important;
  font-family: "Poppins", sans-serif;
  font-size: 12px !important;
  background: #ffffff;
}
::ng-deep .p-component .p-checkbox,
::ng-deep .p-component .p-checkbox {
  width: 16px !important;
  height: 16px !important;
  margin-right: 10px !important;
}
::ng-deep .p-component .p-checkbox .p-checkbox-input,
::ng-deep .p-component .p-checkbox .p-checkbox-input {
  width: 16px !important;
  height: 16px !important;
}
::ng-deep .p-component .p-checkbox .p-checkbox-input .p-checkbox-box,
::ng-deep .p-component .p-checkbox .p-checkbox-input .p-checkbox-box {
  width: 16px !important;
  height: 16px !important;
}
::ng-deep .p-component .p-checkbox .p-checkbox-box {
  width: 16px !important;
  height: 16px !important;
}
::ng-deep .p-multiselect-option {
  margin-bottom: 8px !important;
}
::ng-deep .p-multiselect-dropdown {
  position: relative;
}
::ng-deep .p-multiselect-dropdown svg {
  display: none !important;
  width: 12px !important;
  height: 12px !important;
}
::ng-deep .p-multiselect-dropdown svg path[fill~=currentColor] {
  color: #5E5E5E !important;
}
::ng-deep .p-multiselect-dropdown::after {
  content: "";
  display: block;
  position: absolute;
  right: 0;
  top: 2px;
  width: 12px;
  height: 12px;
  color: #484b59;
  font-size: 12px;
  transition: rotate 0.3s ease;
  font-family: "Font Awesome 6 Free";
  font-weight: 900;
  background-image: url("./media/caret-down-S5OF35ZE.svg");
  background-size: contain;
  background-repeat: no-repeat;
}
::ng-deep .p-multiselect-open .p-multiselect-dropdown::after {
  transform: rotate(180deg);
  transition: rotate 0.3s ease;
}
.fl-count {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #ffffff;
  font-size: 12px;
  background-color: #2E93A1;
}
::ng-deep span.mat-mdc-option.mdc-list-item--disabled {
  cursor: default;
  pointer-events: none;
}
.no-btn-text-only {
  border: none;
  outline: none;
  background-color: transparent;
  padding: 0;
  color: #484b59;
  font-size: 12px;
}
::ng-deep ngb-tooltip-window .tooltip-inner {
  color: #ffffff;
  text-align: left;
  background-color: #484b59;
  max-width: 200px;
  width: 200px;
}
::ng-deep .mat-mdc-option.mdc-list-item--disabled {
  pointer-events: auto !important;
}
::ng-deep .mat-mdc-option.mdc-list-item--disabled .tooltip-wrapper {
  pointer-events: auto;
  cursor: not-allowed;
}
::ng-deep .mat-mdc-option.mdc-list-item--disabled .mdc-list-item__primary-text {
  pointer-events: none;
}
.ms-wrapper {
  position: relative;
}
.ms-wrapper .ms-fake-label {
  position: absolute;
  inset: 0;
  display: flex;
  align-items: center;
  padding-left: 12px;
  background: var(--p-multiselect-background, #fff);
  pointer-events: none;
  z-index: 1;
}
:ng-deep .p-component * {
  width: 100% !important;
}
.hire-btn-primary {
  width: 90px;
}
.hire-btn-primary.disabled {
  background-color: #969696;
  border-color: #969696;
  pointer-events: none;
}
.remove-caret::after {
  display: none;
}
.hire-btn-primary.dropdown-toggle::after {
  display: none !important;
}
.disabled-button {
  pointer-events: none;
  border: none;
  background-color: #cccccc;
  cursor: not-allowed;
  flex-direction: row;
}
/*# sourceMappingURL=hire-quick-search.component-QGPLVF2V.css.map */
